<app-v4-navbar></app-v4-navbar>
<header>
  <app-header-new [headerTitle]="'Privacy Policy'"></app-header-new>
</header>
<main class="tw-px-5 md:tw-px-[15%] tw-py-10 md:tw-py-20">
  <h2 class="tw-text-2xl tw-text-center tw-tracking-tight tw-font-poppins tw-font-bold">
    Installation Guides
  </h2>
  <h3 class="tw-mt-5 md:tw-mt-8 tw-text-2xl md:tw-text-3xl nu-new-black-four tw-font-bold">
    Follow our Product Installation Guides to ensure your project goes smoothly.
  </h3>
  <p class="tw-mt-5 md:tw-mt-8 tw-text-base tw-font-poppins tw-mb-2">
    <span style="color: #333333">Our comprehensive installation guides will support you every step of the
      way! Whether you’re an experienced DIY enthusiast or a first-time patio
      later, our guides are designed to be user-friendly, offering clear,
      detailed instructions to help you confidently achieve professional
      results.</span>
  </p>
  <p class="tw-text-base tw-font-poppins tw-mb-2">
    <span style="color: #333333">Our installation guides cover everything you need to know, from initial
      planning to final touches. We take pride in ensuring that each guide is
      thoroughly researched, created in collaboration with industry
      professionals, and easy to follow so you can complete your project
      smoothly and efficiently. With our expert advice and step-by-step
      guidance, you’ll have the knowledge and assurance to bring your vision to
      life.</span>
  </p>
  <p class="tw-text-base tw-font-poppins tw-mb-2">
    <span style="color: #333333">We also have some great tips to keep your patio looking its best after
      installation. </span><span style="color: #333333">Follow our Cleaning &amp; Sealing Guide to keep your patio
      looking brand
      new all year round and give it some extra protection from the
      elements.</span>
  </p>
  <div class="tw-mt-5 md:tw-mt-8 tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-5">
    <div>
      <figure>
        <a href="/installation-guide" target="_self" aria-label="Goes to detailed installation guide page"
          title="Installation Guide"><img loading="lazy" decoding="async" width="1080" height="1080"
            src="https://nustone-bucket.s3.eu-west-2.amazonaws.com/assets/Paving-Installation-Guide.webp" alt=""
            title="Paving - - Installation Guide" sizes="(max-width: 1080px) 100vw, 1080px" /></a>
      </figure>
    </div>
    <div>
      <figure>
        <a title="Composite Decking - Installation Guide" aria-label="Goes to composite decking installation guide"
          href="/composite-decking-installation-guide" target="_self"><img loading="lazy" decoding="async" width="1080"
            height="1080"
            src="https://nustone-bucket.s3.eu-west-2.amazonaws.com/assets/Composite-Decking-Installation-Guide.webp"
            alt="" title="Composite Decking - Installation Guide" sizes="(max-width: 1080px) 100vw, 1080px" /></a>
      </figure>
    </div>
    <div>
      <figure>
        <a title="Composite Decking - Installation Guide" aria-label="Goes to composite decking installation guide"
          href="/composite-fencing-installation-guide" target="_self"><img loading="lazy" decoding="async" width="1080"
            height="1080"
            src="https://nustone-bucket.s3.eu-west-2.amazonaws.com/assets/Composite-Fencing-Installation-Guide.webp"
            alt="" title="Composite Fencing - Installation Guide" sizes="(max-width: 1080px) 100vw, 1080px" /></a>
      </figure>
    </div>
    <div>
      <figure>
        <a title="CLEANING &amp; SEALING GUIDE" aria-label="Goes cleaning and sealing guide page"
          href="/cleaning-sealing-guide" target="_self"><img loading="lazy" decoding="async"
            width="1080" height="1080"
            src="https://nustone-bucket.s3.eu-west-2.amazonaws.com/assets/CLEANING-SEALING-GUIDE.webp" alt=""
            title="CLEANING &amp; SEALING GUIDE" sizes="(max-width: 1080px) 100vw, 1080px" /></a>
      </figure>
    </div>
  </div>

  <h3 class="tw-mt-5 md:tw-mt-8 tw-tracking-tighter tw-text-2xl tw-font-poppins tw-font-bold">
    Contact Us
  </h3>
  <p class="tw-mt-2 tw-text-base tw-font-poppins tw-mb-2">
    If there&#8217;s anything else you can help with, just let us know!
  </p>
  <p class="tw-text-base tw-font-poppins tw-mb-2">
    <span style="color: #000000">Find the answers to our most frequently asked questions
      <strong><a title="Nustone support" aria-label="Goes to support page" style="color: #000000"
          href="https://nustone.co.uk/support">here</a></strong>. Alternatively, to speak
      to a team member, contact us on
      <a title="Nustone support contact number" aria-label="Call nustone support" class="editor-rtfLink"
        href="tel:01206%20700%20599" target="_blank" rel="noopener"><strong>01206 700
          599</strong></a>
      or
      <a title="Nustone support mail" aria-label="Mail to customer support" class="editor-rtfLink"
        href="mailto:support@nustone.co.uk" target="_blank" rel="noopener"><strong>
          {{ "support@nustone.co.uk" }}
        </strong></a>.</span>
  </p>
  <div class="tw-mt-8">
    <!-- Rendered in the browser only (Trustpilot swaps it for an iframe). -->
  <app-trustbox ngSkipHydration template_Id="54ad5defc6454f065c28af8b" height="240px" />
  </div>
</main>
<app-footer></app-footer>